var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { property_type, property_features, canonical } = options; 
__p+='\n\n<div class="subsection">\n  <h2 class="header-subsection">\n    '+
((__t=( property_type == "for_sale" ? "Property Features" : "Community Amenities" ))==null?'':__t)+
'\n  </h2>\n  <div class="features js-features-load-more">\n    ';
 property_features.forEach((feature) => { 
__p+='\n    <div class="clearfix">\n      <h4 class="title-subsection-sm">'+
((__t=( feature.feature_category ))==null?'':__t)+
'</h4>\n      <ul class="row list-default list">\n        ';
 feature.feature_values.forEach((item) => { 
__p+='\n        <li class="col-qv-sm-6">\n          <span>'+
((__t=( item ))==null?'':__t)+
'</span>\n        </li>\n        ';
 }) 
__p+='\n      </ul>\n    </div>\n    ';
 }) 
__p+='\n    <div class="clearfix">\n      <a\n        href="'+
((__t=( canonical ))==null?'':__t)+
'"\n        target="_blank"\n        class="visible-qv-xs-block"\n        data-omtag="ldp:quickview:inline:expand"\n      >\n        <span class="font-semibold">View Full Details</span\n        ><i class="ra ra-external-link icon-space-left-lg"></i>\n      </a>\n    </div>\n  </div>\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-subsec-property-features.jst.ejs